/* RESPONSIBLE TEAM: team-reporting */

import { ChartSeries } from '@/features/report-snapshots/components/charts/utils/chart-data';
import { PieChartSeriesData } from '@/features/report-snapshots/components/charts/utils/chart-pie-data';
import { COLOR_MAPPINGS, METRIC_DISPLAY_OVERRIDES } from '@/features/report-snapshots/constants';
import { ChartDefinition } from '@/features/report-snapshots/api/schema';

export function assignColorToSeriesItem(seriesItem: ChartSeries, chartDefinition: ChartDefinition) {
  if (
    chartDefinition.segmentBy &&
    Object.keys(COLOR_MAPPINGS).includes(chartDefinition.segmentBy)
  ) {
    const colorMapping = COLOR_MAPPINGS[chartDefinition.segmentBy as METRIC_DISPLAY_OVERRIDES];
    const segmentKey = seriesItem.name;
    if (segmentKey in colorMapping) {
      seriesItem.color = colorMapping[segmentKey as keyof typeof colorMapping];
    }
  }
}

export function assignColorToSeries(series: ChartSeries[], chartDefinition: ChartDefinition) {
  if (!['line', 'area'].includes(chartDefinition.visualizationType)) {
    if (
      chartDefinition.viewBy &&
      Object.keys(COLOR_MAPPINGS).includes(chartDefinition.viewBy) &&
      series.length === 1
    ) {
      const colorMapping = COLOR_MAPPINGS[chartDefinition.viewBy as METRIC_DISPLAY_OVERRIDES];
      series[0].data.forEach((dataItem) => {
        const viewByKey = dataItem.name;
        if (viewByKey in colorMapping) {
          dataItem.color = colorMapping[viewByKey as keyof typeof colorMapping];
        }
      });
    }
  }
}

export function assignColorToSeriesItemViewBy(
  seriesItem: ChartSeries | PieChartSeriesData,
  chartDefinition: ChartDefinition,
) {
  if (chartDefinition.viewBy && Object.keys(COLOR_MAPPINGS).includes(chartDefinition.viewBy)) {
    const colorMapping = COLOR_MAPPINGS[chartDefinition.viewBy as METRIC_DISPLAY_OVERRIDES];
    const segmentKey = seriesItem.name;
    if (segmentKey in colorMapping) {
      seriesItem.color = colorMapping[segmentKey as keyof typeof colorMapping];
    }
  }
}
